import PricingBlock from 'components/Pricing';

const PricesPage = () => {
  return <PricingBlock />;
};

export default PricesPage;
